import APIV5 from '~/models/api';

/* globals Knitiv */

export default class MenuController {
	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ITimeoutService} $timeout
	 */
	constructor(
		$rootScope,
		$timeout,
	) {
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;

		/** @type {boolean} */
		this.isOpen = false;

		/** @type {boolean} */
		this.loading = false;

		/** @type {import('@knitiv/api-client-javascript').UIGetContentMenuItem[]} */
		this.menu = [];
	}

	async loadMenu() {
		this.menu.length = 0;
		this.loading = true;
		const response = await APIV5.instance.uiGetContent({ path: 'MENU' }, { id: 'menu' });
		if (response && Array.isArray(response.result)) {
			/** @type {import('@knitiv/api-client-javascript').UIGetContentMenuItem[]} */
			const menuItems = response.result;
			this.menu.push(...menuItems);
		}
		this.loading = false;
	}

	$onInit() {
		this.$rootScope.$on('User.login', () => this.loadMenu());
		this.$rootScope.$on('User.logout', () => {
			this.menu.length = 0;
		});
		this.$rootScope.$on('$locationChangeSuccess', () => {
			this.isOpen = false;
		});

		if (this.$rootScope.context?.token) {
			(async () => this.loadMenu())();
		}
	}
}
